<template class="full-height">
  <div class="full-height">
    <!-- 領隊資料檢視 -->
    <el-dialog
      @opened="leaderViewOpenedHandle"
      top="2%"
      append-to-body
      :title="`領隊資料檢視`"
      :visible.sync="dialogLeaderViewVisible"
      width="70%"
    >
      <leader-data
        v-if="dialogLeaderViewVisible"
        style="height: calc(100vh - 210px); overflow-y: auto"
        :userID="parseInt(selectedLeaderUserID)"
      ></leader-data>

      <span slot="footer" class="dialog-footer">
        <el-button type="danger" @click="dialogLeaderViewVisible = false">關 閉</el-button>
      </span>
    </el-dialog>

    <el-dialog
      @closed="onDialogClosed"
      v-loading="formLoading"
      top="3vh"
      title="領隊資料維護"
      :visible.sync="dialogFormVisible"
      append-to-body
      :width="isAdd ? '30%' : '70%'"
      show-close
    >
      <el-row>
        <el-col :span="isAdd ? 24 : 13">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <el-alert
                title="預設密碼為西元生日，ex:19880101"
                type="warning"
                effect="dark"
                :closable="false"
                style="color: #4b4b4b"
              ></el-alert>
            </div>

            <div class="leader-data">
              <el-form ref="dynamicValidateForm" :model="formData" :disabled="!authEdit && !isAdd">
                <el-form-item label="所屬旅行社" :label-width="formLabelWidth" prop="agencyCode">
                  <el-select
                    :disabled="agencyCode ? true : false"
                    v-model="formData.agencyCode"
                    filterable
                    placeholder="請選擇"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in agencyList"
                      :key="item.key"
                      :label="item.val"
                      :value="item.key"
                    />
                  </el-select>
                </el-form-item>

                <el-form-item
                  label="領隊姓名"
                  :label-width="formLabelWidth"
                  prop="name"
                  :rules="[
                    {
                      required: true,
                      message: '請輸入領隊姓名',
                      trigger: 'blur',
                    },
                  ]"
                >
                  <el-input v-model="formData.name" autocomplete="off" />
                </el-form-item>

                <el-form-item
                  v-if="!isAdd"
                  label="領隊暱稱"
                  :label-width="formLabelWidth"
                  prop="name"
                  :rules="[
                    {
                      required: true,
                      message: '請輸入領隊暱稱',
                      trigger: 'blur',
                    },
                  ]"
                >
                  <el-input v-model="formData.nickName" autocomplete="off" />
                </el-form-item>

                <el-form-item
                  label="領隊生日"
                  :label-width="formLabelWidth"
                  prop="birthday"
                  :rules="[
                    {
                      required: true,
                      message: '請輸入領隊生日',
                      trigger: 'blur',
                    },
                  ]"
                >
                  <el-date-picker
                    style="width: 100%"
                    v-model="formData.birthday"
                    type="date"
                    placeholder="請選擇領隊生日"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                  >
                  </el-date-picker>
                </el-form-item>

                <el-form-item
                  label="領隊電話"
                  :label-width="formLabelWidth"
                  prop="mobile"
                  :rules="[
                    {
                      required: true,
                      message: '請輸入領隊電話',
                      trigger: 'blur',
                    },
                    {
                      required: true,
                      pattern: pattern.mobile,
                      message: '電話格式不正確',
                      trigger: 'blur',
                    },
                  ]"
                >
                  <el-input v-model="formData.mobile" autocomplete="off" />
                </el-form-item>
                <!-- <el-form-item
                  label="領隊描述"
                  :label-width="formLabelWidth"
                  prop="description"
                  :rules="[
                    {
                      required: true,
                      message: '請輸入領隊描述',
                      trigger: 'blur',
                    },
                  ]"
                >
                  <el-input v-model="formData.description" autocomplete="off" />
                </el-form-item> -->

                <el-form-item label="領隊介紹" :label-width="formLabelWidth" v-if="!isAdd">
                  <el-input v-model="formData.selfDescription" type="textarea" :rows="3" />
                </el-form-item>

                <el-form-item label="領隊經歷" :label-width="formLabelWidth" v-if="!isAdd">
                  <el-input v-model="formData.experience" type="textarea" :rows="3" />
                </el-form-item>

                <el-form-item label="證照說明" :label-width="formLabelWidth" v-if="!isAdd">
                  <el-input v-model="formData.certificatesRemark" type="textarea" :rows="3" />
                </el-form-item>

                <el-form-item label="專長" :label-width="formLabelWidth" v-if="!isAdd">
                  <el-select
                    v-model="formData.specialties"
                    multiple
                    filterable
                    allow-create
                    default-first-option
                    placeholder="請選擇或輸入專長"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in specialtyOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>

                <template v-if="!isAdd">
                  <el-divider content-position="left">履歷隱私與邀約</el-divider>
                  <el-form-item label="公開履歷" :label-width="formLabelWidth">
                    <el-switch v-model="formData.privacy.isProfilePublic" />
                  </el-form-item>
                  <el-form-item label="接受邀約" :label-width="formLabelWidth">
                    <el-switch v-model="formData.privacy.acceptInvitations" />
                  </el-form-item>
                  <el-form-item label="公開年齡" :label-width="formLabelWidth">
                    <el-switch v-model="formData.privacy.showAge" />
                  </el-form-item>
                  <el-form-item label="公開居住地" :label-width="formLabelWidth">
                    <el-switch v-model="formData.privacy.showResidence" />
                  </el-form-item>
                </template>
              </el-form>
            </div>
          </el-card>
        </el-col>
        <el-col :offset="1" :span="10" v-if="!isAdd">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>頭像</span>
            </div>
            <Upload
              ref="uploadAvatar"
              :accept="'.jpg,.jpeg,.png,.webp'"
              :data-obj="fileObj"
              :use-drag="false"
              :action="'Agency'"
              :auto-upload="false"
              :multiple="false"
              :limit-file-count="1"
              :show-file-list="true"
              :form-on-loading-parent="formOnLoading"
              :btn-txt="'選擇頭像'"
              :before-file-list="formData.avatar"
              :show-limit="false"
            />
          </el-card>
        </el-col>
        <el-col :offset="1" :span="10" v-if="!isAdd">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>領隊照片</span>
            </div>
            <!-- <el-tag
              type="warning"
              style="
                height: auto;
                white-space: break-spaces;
                font-size: 14px;
                margin-bottom: 5px;
              "
              >圖片須為.jpg,.jpeg,.png格式，限制不超過2000MB</el-tag
            > -->
            <div>
              <Upload
                ref="upload1"
                :accept="'.jpg,.jpeg,.png'"
                :data-obj="fileObj"
                :use-drag="false"
                :action="'Agency'"
                :auto-upload="false"
                :show-file-list="true"
                :form-on-loading-parent="formOnLoading"
                :btn-txt="'上傳'"
                :before-file-list="formData.file1"
                :show-limit="false"
              />
            </div>
          </el-card>
        </el-col>

        <el-col :offset="1" :span="10" style="margin-top: 20px" v-if="!isAdd">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>相關證照</span>
            </div>
            <div>
              <Upload
                ref="upload2"
                :data-obj="fileObj"
                :accept="'.jpg,.jpeg,.png'"
                :use-drag="false"
                :action="'Agency'"
                :auto-upload="false"
                :show-file-list="true"
                :form-on-loading-parent="formOnLoading"
                :btn-txt="'上傳'"
                :before-file-list="formData.file2"
                :show-limit="false"
              />
            </div>
          </el-card>
        </el-col>
      </el-row>

      <div slot="footer" class="dialog-footer">
        <el-button
          type="warning"
          @click="saveData('dynamicValidateForm')"
          v-if="isAdd || authEdit"
          style="color: #4b4b4b"
          >儲 存</el-button
        >

        <el-button @click="dialogFormVisible = false" :type="isAdd || authEdit ? '' : 'danger'">{{
          isAdd || authEdit ? '取 消' : '關 閉'
        }}</el-button>
      </div>
    </el-dialog>

    <el-form :inline="true" class="filter-form" @submit.native.prevent>
      <el-form-item label="查詢">
        <el-input
          v-model="listQuery.qry"
          placeholder="輸入旅行社代碼/領隊暱稱/領隊姓名"
          @keyup.enter.native="getList"
        />
      </el-form-item>

      <el-button
        type="primary"
        @click="getList"
        icon="el-icon-search"
        circle
        style="margin-top: 8px; margin-left: 5px"
        :disabled="listLoading"
      ></el-button>
      <el-button
        type="warning"
        @click="addData"
        circle
        icon="el-icon-plus"
        :disabled="listLoading"
      ></el-button>
      <!-- <el-button
        style="cursor: pointer"
        v-loading="listLoading"
        type="success"
        icon="el-icon-refresh-left"
        circle
        @click="refresh()"
      ></el-button> -->
      <el-button
        style="cursor: pointer"
        type="success"
        :loading="listLoading"
        circle
        icon="el-icon-refresh-left"
        @click="refresh()"
      ></el-button>

      <!-- <el-form-item label="名稱查詢">
        <el-select placeholder="輸入名稱">
          <el-option label="区域一" value="shanghai" />
          <el-option label="区域二" value="beijing" />
        </el-select>
      </el-form-item> -->
      <!-- <el-form-item>
        <el-button type="primary" @click="getList">查詢</el-button>
        <el-button type="success" @click="addData">建立</el-button>
      </el-form-item>
      <el-form-item>
        <el-button
          size="mini"
          style="cursor: pointer"
          v-loading="listLoading"
          type="success"
          icon="el-icon-refresh-left"
          circle
          @click="refresh()"
        ></el-button>
      </el-form-item> -->
    </el-form>

    <div style="position: relative; height: 80%">
      <el-table
        ref="formDetailsTable"
        v-loading="listLoading"
        :data="list"
        border
        fit
        highlight-current-row
        style="width: 100%"
        height="100%"
        @sort-change="sortChange"
      >
        <el-table-column align="center" label="數量" width="1" type="expand">
          <template slot-scope="scope">
            <el-table
              size="mini"
              :data="scope.row.travels"
              border
              style="width: 100%"
              height="200"
              :row-class-name="tableRowClassName"
            >
              <!-- <el-table-column align="center" label="項次" width="50">
                <template slot-scope="scope">
                  {{ scope.$index + 1 }}
                </template>
              </el-table-column> -->

              <el-table-column align="center" label="" :min-width="50">
                <template slot-scope="scope" v-if="scope.row.beginDateTime1">
                  <span style="font-size:14px;text-align:left;'">{{ scope.row.travelName1 }}</span>
                  <div>
                    <el-tag size="mini">
                      出發
                      <span style="color: red">{{ `${scope.row.beginDateTime1}` }}</span>
                      - 回程
                      <span style="color: red">{{ `${scope.row.endDateTime1}` }}</span>
                    </el-tag>
                  </div>
                </template>
              </el-table-column>
              <el-table-column align="center" label="" :min-width="50">
                <template slot-scope="scope" v-if="scope.row.beginDateTime2">
                  <span style="font-size:14px;text-align:left;'">{{ scope.row.travelName2 }}</span>
                  <div>
                    <el-tag size="mini">
                      出發
                      <span style="color: red">{{ `${scope.row.beginDateTime2}` }}</span>
                      - 回程
                      <span style="color: red">{{ `${scope.row.endDateTime2}` }}</span>
                    </el-tag>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </el-table-column>

        <el-table-column align="center" label="項次" width="60">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>

        <!-- <el-table-column align="center" label="旅行社代碼" width="200">
          <template slot-scope="scope">
            <span>{{ scope.row.agencyCode }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="旅行社名稱">
          <template slot-scope="scope">
            <span>{{ scope.row.agencyName }}</span>
          </template>
        </el-table-column> -->
        <el-table-column align="center" label="手機號碼" width="160">
          <template slot-scope="scope">
            <span>{{ scope.row.mobile }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="領隊姓名" width="200">
          <template slot-scope="{ row }">
            <span>{{ row.name }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="領隊暱稱" width="120">
          <template slot-scope="{ row }">
            <span>{{ row.nickName }}</span>
          </template>
        </el-table-column>

        <!-- <el-table-column align="center" label="簽約設定" width="180">
        <template slot-scope="scope">
          <el-switch
            @change="setLeaderContract(scope.row)"
            v-model="scope.row.contract"
            active-text="簽約"
            :active-value="true"
            :inactive-value="false"
            inactive-text="非簽約"
          >
          </el-switch>
        </template>
      </el-table-column> -->

        <el-table-column align="center" label="查看" width="120">
          <template slot-scope="scope">
            <el-button
              :type="
                checkPermission(['ITA-DEV', 'ITA-ADMIN', 'ITA-ADM-STAFF']) ? 'success' : 'info'
              "
              @click="editData(scope.row)"
              size="mini"
            >
              {{
                checkPermission(['ITA-DEV', 'ITA-ADMIN', 'ITA-ADM-STAFF']) ? '編輯' : '查看'
              }}</el-button
            >
          </template>
        </el-table-column>

        <el-table-column align="center" label="出團數" width="120">
          <template slot-scope="scope">
            <el-tag
              @click="toogleExpand(scope.row)"
              type="success"
              style="font-size: 15px; font-weight: bold; cursor: pointer"
              >{{ scope.row.toursCount }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column
          align="center"
          label="滿意度"
          width="120"
          sortable
          prop="satisfactionAnalysis"
        >
          <template slot-scope="scope">
            <el-tag
              style="font-size: 20px; font-weight: bold"
              :type="getSatisfactionAnalysisStyle(scope.row.satisfaction.satisfactionAnalysis)"
              v-if="scope.row.satisfaction.satisfactionAnalysis"
              >{{ scope.row.satisfaction.satisfactionAnalysis }} ({{
                scope.row.satisfaction.travelersCount
              }})
            </el-tag>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <pagination
      v-show="total > 0"
      layout="prev, pager, next"
      :total="total"
      :page.sync="listQuery.page"
      :limit.sync="listQuery.limit"
      @pagination="getList"
    />
  </div>
</template>

<script>
import checkPermission from '@/utils/permission' // 权限判断函数
import Pagination from '@/components/Pagination' // Secondary package based on el-pagination
import { getTourLeaderList, saveTourLeaderInfo, setLeaderContract } from '@/api/agency'
import Upload from '@/views/ita/components/fileUpload.vue'

import { getAgencyOptions } from '@/api/travel'
import { jsonToFormData, convertFileToBase64 } from '@/utils/funcs'
import { downloadAs } from '@/utils/funcs'
import { MessageBox, Message } from 'element-ui'
import LeaderData from '@/views/ita/components/leaderViewData.vue'
import { requireSuccessfulResponse, toPagedResult } from '@/utils/tourLeaderApi'

const LEADER_DRAFT_STORAGE_KEY = 'leaderDraft:formData'
const LEADER_DRAFT_FIELDS = [
  'id',
  'originalUpdateDate',
  'agencyCode',
  'agencyName',
  'name',
  'nickName',
  'birthday',
  'mobile',
  'description',
  'selfDescription',
  'experience',
  'certificatesRemark',
  'specialties',
  'privacy',
]

export default {
  name: 'TourLeaderTable',
  components: { Pagination, Upload, LeaderData },
  props: {
    // 外部傳入的物件
    agencyCode: {
      type: String,
      default: null,
    },
    // accept: {
    //   type: String,
    //   default: "",
    // },
    // dataObj: {
    //   type: Object,
    //   default: { id: 0, type: "", user: "" },
    // },
    // buttonStyle: {
    //   type: Object,
    //   default: null,
    // },
  },
  data() {
    return {
      pattern: {
        email:
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        mobile: /^09[0-9]{8}$/,
      },
      selectedLeaderUserID: null,
      dialogLeaderViewVisible: false,
      authEdit: false,
      fileObj: { id: 0, type: 'tourLeaderInfo', user: '' },
      defaultDate: '1990-01-01',
      agencyList: [],
      isAdd: true,
      formLabelWidth: '120px',
      formData: {
        id: null,
        originalUpdateDate: null,
        birthday: null,
        avatar: [],
        file1: [],
        file2: [],
        specialties: [],
        privacy: {
          isProfilePublic: false,
          acceptInvitations: false,
          showAge: false,
          showResidence: false,
        },
      },
      specialtyOptions: [
        { label: '日本線', value: '日本線' },
        { label: '歐洲線', value: '歐洲線' },
        { label: '東南亞線', value: '東南亞線' },
        { label: '商務團', value: '商務團' },
        { label: '遊學團', value: '遊學團' },
      ],
      dialogFormVisible: false,
      listLoading: false,
      formLoading: false,
      listQuery: {
        qry: '',
        agencyCode: '',
        date: '',
        status: null,
        page: 1,
        limit: 20,
        sort: '-id',
      },
      total: 0,
      list: [],
    }
  },
  watch: {
    agencyCode: function (value) {
      if (value) {
        this.listQuery.agencyCode = value
        this.getList()
      }
    },
  },
  async created() {
    this.listQuery.agencyCode = this.agencyCode
    await this.getAgencyOptions()
    await this.getList()
    this.maybeRestoreLeaderDraft()
  },
  methods: {
    checkPermission,
    async refresh() {
      this.defaultListyQuerySetting()
      await this.getList()
    },
    sortChange(data) {
      const { prop, order } = data
      debugger
      this.sortByColumn(prop, order)
    },
    sortByColumn(sort, order) {
      if (order === 'ascending') {
        this.listQuery.sort = `+${sort}`
      } else if (order === 'descending') {
        this.listQuery.sort = `-${sort}`
      } else {
        const s = this.listQuery.sort[0]
        if (s === '+') {
          this.listQuery.sort = `-${sort}`
        } else if (s === '-') {
          this.listQuery.sort = `+${sort}`
        } else {
          this.listQuery.sort = `+${sort}`
        }
      }
      this.handleFilter()
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    getSatisfactionAnalysisStyle(v) {
      let tryParseInt = parseInt(v)
      let style = ''
      //旅客
      switch (true) {
        case tryParseInt <= 2.9:
          style = 'danger'
          break
        case tryParseInt <= 3.9:
          style = 'warning'
          break
        default:
          style = 'success'
          break
      }

      return style
    },
    leaderViewOpenedHandle() {
      let sID = this.selectedLeaderUserID
      this.selectedLeaderUserID = null
      setTimeout(() => {
        this.selectedLeaderUserID = sID
      }, 300)
    },
    toogleExpand(row) {
      console.log(row)
      let $table = this.$refs.formDetailsTable
      $table.toggleRowExpansion(row)
    },
    tableRowClassName({ row, rowIndex }) {
      return 'success-row'
    },
    async setLeaderContract(row) {
      if (!this.agencyCode) {
        alert(`無法取得登入者旅行社代碼，無法設定。`)
        return
      }
      let payload = {
        userID: row.id,
        agencyCode: this.agencyCode,
        setContract: row.contract,
      }
      this.listLoading = true
      try {
        let resp = await setLeaderContract(payload)
      } catch (error) {
        console.log(error)
        Message({
          message: '合約設定失敗，請稍後再試',
          type: 'error',
          duration: 5 * 1000,
        })
      } finally {
        await this.getList()
        this.listLoading = false
      }
    },
    defaultListyQuerySetting() {
      this.listQuery = {
        qry: '',
        agencyCode: this.agencyCode,
        date: '',
        status: null,
        page: 1,
        limit: 20,
        sort: '-id',
      }
    },
    onDialogClosed() {
      const uploadRefs = ['uploadAvatar', 'upload1', 'upload2']
      uploadRefs.forEach(refName => {
        if (this.$refs[refName]) {
          this.$refs[refName].clearFiles()
        }
      })
    },
    formOnLoading() {
      this.formLoading = true
    },
    async getAgencyOptions() {
      this.listLoading = true
      await getAgencyOptions().then(response => {
        this.agencyList = response.data
        this.listLoading = false
      })
    },
    async addData() {
      const vm = this
      vm.isAdd = true
      vm.formData = {
        id: null,
        originalUpdateDate: null,
        birthday: this.defaultDate,
        agencyCode: this.agencyCode,
        avatar: [],
        file1: [],
        file2: [],
        specialties: [],
        privacy: {
          isProfilePublic: false,
          acceptInvitations: false,
          showAge: false,
          showResidence: false,
        },
      }
      vm.dialogFormVisible = true
    },
    filterFiles(type, files) {
      let result = []
      switch (type) {
        case 1: // 未上傳檔案
          result = files.filter(f => {
            return typeof f.raw !== 'undefined'
          })
          break
        case 2: // 已上傳檔案ID
          files
            .filter(f => {
              return typeof f.raw === 'undefined'
            })
            .forEach(f => {
              result.push(f.uid)
            })

          break
      }
      return result
    },
    snapshotLeaderDraft() {
      try {
        const snapshot = {}
        LEADER_DRAFT_FIELDS.forEach(key => {
          if (typeof this.formData[key] !== 'undefined') {
            snapshot[key] = this.formData[key]
          }
        })
        sessionStorage.setItem(
          LEADER_DRAFT_STORAGE_KEY,
          JSON.stringify({ savedAt: new Date().toISOString(), formData: snapshot })
        )
      } catch (e) {
        // 私密模式或配額不足時不阻擋送出
      }
    },
    clearLeaderDraft() {
      try {
        sessionStorage.removeItem(LEADER_DRAFT_STORAGE_KEY)
      } catch (e) {
        // 忽略清除失敗，不影響主流程
      }
    },
    maybeRestoreLeaderDraft() {
      let raw = null
      try {
        raw = sessionStorage.getItem(LEADER_DRAFT_STORAGE_KEY)
      } catch (e) {
        return
      }
      if (!raw) {
        return
      }
      let parsed = null
      try {
        parsed = JSON.parse(raw)
      } catch (e) {
        return
      }
      const draft = parsed && parsed.formData ? parsed.formData : parsed
      if (!draft || typeof draft !== 'object') {
        return
      }
      const applyDraft = () => {
        const restored = {}
        LEADER_DRAFT_FIELDS.forEach(key => {
          if (typeof draft[key] !== 'undefined') {
            restored[key] = draft[key]
          }
        })
        this.formData = Object.assign({}, this.formData, restored)
      }
      const discardDraft = () => {
        this.clearLeaderDraft()
      }
      const promptText = '偵測到未送出的資料，是否還原？'
      if (this.$confirm) {
        this.$confirm(promptText, '提示', {
          confirmButtonText: '還原',
          cancelButtonText: '捨棄',
          type: 'warning',
        })
          .then(() => {
            applyDraft()
          })
          .catch(() => {
            discardDraft()
          })
        return
      }
      if (typeof MessageBox !== 'undefined' && MessageBox.confirm) {
        MessageBox.confirm(promptText, '提示', {
          confirmButtonText: '還原',
          cancelButtonText: '捨棄',
          type: 'warning',
        })
          .then(() => {
            applyDraft()
          })
          .catch(() => {
            discardDraft()
          })
        return
      }
      if (confirm(promptText)) {
        applyDraft()
      } else {
        discardDraft()
      }
    },
    async saveData(formName) {
      const avatarUpload = this.$refs['uploadAvatar']
      const f1 = this.$refs['upload1']
      const f2 = this.$refs['upload2']
      const vm = this
      if (!confirm(`確定要儲存資料?`)) {
        return false
      }
      this.$refs[formName].validate(async valid => {
        if (valid) {
          vm.formLoading = true
          vm.snapshotLeaderDraft()

          // 初始化物件 不然會帶null到集合裡面
          vm.formData.fileIDs = []
          vm.formData.fileInfo = []

          if (vm.formData.birthday) {
            var pattern = /^([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))$/
            //If the inputString is NOT a match
            if (!pattern.test(vm.formData.birthday)) {
              alert('生日日期格式錯誤，例：1980-02-02')
              vm.formLoading = false

              return
            }
          }

          let payload = {
            id: vm.formData.id,
            originalUpdateDate: vm.formData.originalUpdateDate || null,
            agencyCode: vm.formData.agencyCode,
            agencyName: vm.formData.agencyName,
            name: vm.formData.name,
            nickName: vm.formData.nickName,
            birthday: vm.formData.birthday,
            mobile: vm.formData.mobile,
            description: vm.formData.description,
            selfDescription: vm.formData.selfDescription,
            experience: vm.formData.experience,
            certificatesRemark: vm.formData.certificatesRemark,
            specialties: vm.normalizeSpecialties(vm.formData.specialties),
            privacy: Object.assign(
              {
                isProfilePublic: false,
                acceptInvitations: false,
                showAge: false,
                showResidence: false,
              },
              vm.formData.privacy
            ),
            fileIDs: [],
          }

          payload.fileInfo = []
          if (avatarUpload && f1 && f2) {
            if (!vm.validateProfileImages([avatarUpload, f1, f2])) {
              vm.formLoading = false
              return
            }

            const filteredAvatarFiles = this.filterFiles(1, avatarUpload.fileList)
            const filteFile1Rel1 = this.filterFiles(1, f1.fileList)
            const filteFile1Rel2 = this.filterFiles(1, f2.fileList)

            const oldFileIDs = [
              ...this.filterFiles(2, avatarUpload.fileList),
              ...this.filterFiles(2, f1.fileList),
              ...this.filterFiles(2, f2.fileList),
            ]

            oldFileIDs.forEach(f => {
              // 舊檔案ID
              payload.fileIDs.push(f)
            })

            const avatarFileModel = {
              type: 1,
              files: [],
            }
            for (var avatarIndex = 0; avatarIndex < filteredAvatarFiles.length; avatarIndex++) {
              const avatarFile = filteredAvatarFiles[avatarIndex]
              await convertFileToBase64(avatarFile.raw).then(resolve => {
                avatarFileModel.files.push({
                  fileName: avatarFile.name,
                  base64: resolve,
                })
              })
            }
            payload.fileInfo.push(avatarFileModel)

            // base64版本
            // 領隊相片
            let fileModel1 = {
              type: 2,
              files: [],
            }
            for (var i = 0; i < filteFile1Rel1.length; i++) {
              const f = filteFile1Rel1[i]

              await convertFileToBase64(f.raw).then((resolve, reject) => {
                fileModel1.files.push({
                  fileName: f.name,
                  base64: resolve,
                })
              })
            }

            payload.fileInfo.push(fileModel1)

            // 證照相片
            let fileMode2 = {
              type: 3,
              files: [],
            }
            for (var i = 0; i < filteFile1Rel2.length; i++) {
              const f = filteFile1Rel2[i]

              await convertFileToBase64(f.raw).then((resolve, reject) => {
                fileMode2.files.push({
                  fileName: f.name,
                  base64: resolve,
                })
              })
            }
            payload.fileInfo.push(fileMode2)
          }

          //formData處理
          // const form = jsonToFormData(this.formData);
          // form.append(`agencyCode`, this.agencyCode);

          // const filteFile1Rel1 = this.filterFiles(1, f1.fileList);
          // const filteFile1Rel2 = this.filterFiles(1, f2.fileList);

          // const oldFileIDs = [
          //   ...this.filterFiles(2, f1.fileList),
          //   ...this.filterFiles(2, f2.fileList),
          // ];

          // oldFileIDs.forEach((f) => {
          //   // 舊檔案ID
          //   form.append(`fileIDs`, f);
          // });

          // const containerIndex = filteFile1Rel1.length == 0 ? 0 : 1;

          // // base64版本
          // // 領隊相片
          // for (var i = 0; i < filteFile1Rel1.length; i++) {
          //   const f = filteFile1Rel1[i];
          //   form.append(`fileInfo[0].type`, 2);
          //   await convertFileToBase64(f.raw).then((resolve, reject) => {
          //     form.append(`fileInfo[0].files[${i}].fileName`, f.name);
          //     form.append(`fileInfo[0].files[${i}].base64`, resolve);
          //   });
          // }

          // // 證照相片
          // for (var i = 0; i < filteFile1Rel2.length; i++) {
          //   const f = filteFile1Rel2[i];
          //   form.append(`fileInfo[${containerIndex}].type`, 3);
          //   await convertFileToBase64(f.raw).then((resolve, reject) => {
          //     form.append(
          //       `fileInfo[${containerIndex}].files[${i}].fileName`,
          //       f.name
          //     );
          //     form.append(
          //       `fileInfo[${containerIndex}].files[${i}].base64`,
          //       resolve
          //     );
          //   });
          // }

          // contebt-type form-data 版本
          // 領隊相片
          // for (var i = 0; i < f1.fileList.length; i++) {
          //   let f = f1.fileList[i];
          //   form.append(`fileInfo[0].type`, 2);
          //   form.append(`fileInfo[0].files`, f.raw);
          // }

          // //證照相片
          // for (var i = 0; i < f2.fileList.length; i++) {
          //   let f = f2.fileList[i];
          //   form.append(`fileInfo[${containerIndex}].type`, 3);
          //   form.append(`fileInfo[${containerIndex}].files`, f.raw);
          // }

          await saveTourLeaderInfo(payload)
            .then(async response => {
              requireSuccessfulResponse(response)
              vm.clearLeaderDraft()
              if (f1) {
                f1.clearFiles()
              }
              if (f2) {
                f2.clearFiles()
              }
              if (avatarUpload) {
                avatarUpload.clearFiles()
              }

              setTimeout(async () => {
                vm.dialogFormVisible = false
                vm.formLoading = false
                await vm.getList()
                vm.formData = vm.list.filter(f => {
                  return f.id == response.data
                })[0]

                Message({
                  message: '資料處理完成',
                  type: 'success',
                  duration: 5 * 1000,
                })
              }, 500)
            })
            .catch(error => {
              console.log(error)
              vm.formLoading = false
              Message({
                message: '儲存失敗，請稍後再試',
                type: 'error',
                duration: 5 * 1000,
              })
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    async getList() {
      const vm = this
      vm.listLoading = true
      try {
        const result = toPagedResult(await getTourLeaderList(this.listQuery))
        if (result.items) {
          result.items.forEach(f => {
            if (f.agencyCode) {
              f.contract = true
            } else {
              f.contract = false
            }
          })
        }
        this.list = result.items
        this.total = result.total
      } catch (error) {
        this.list = []
        this.total = 0
        Message({
          message: '領隊列表載入失敗，請手動重新整理',
          type: 'error',
          duration: 5 * 1000,
        })
      } finally {
        vm.listLoading = false
      }
    },
    editData(d) {
      const vm = this
      vm.isAdd = false
      vm.selectedLeaderUserID = d.id
      vm.authEdit = checkPermission(['ITA-DEV', 'ITA-ADMIN', 'ITA-ADM-STAFF'])
      vm.formData = JSON.parse(JSON.stringify(d))
      vm.formData.specialties = vm.normalizeSpecialties(vm.formData.specialties)
      vm.formData.privacy = Object.assign(
        {
          isProfilePublic: false,
          acceptInvitations: false,
          showAge: false,
          showResidence: false,
        },
        vm.formData.privacy || vm.formData.privacySetting
      )

      if (!vm.authEdit && !vm.isAdd) {
        vm.dialogLeaderViewVisible = true
      } else {
        const fileInfo = Array.isArray(vm.formData.fileInfo) ? vm.formData.fileInfo : []
        const avatar = fileInfo.filter(v => {
          return v.type == 1
        })
        const file1 = fileInfo.filter(v => {
          return v.type == 2
        })
        const file2 = fileInfo.filter(v => {
          return v.type == 3
        })

        vm.formData.avatar = avatar.length > 0 ? avatar[0].files : []
        if (file1.length > 0) {
          vm.formData.file1 = file1[0].files
        } else {
          vm.formData.file1 = []
        }
        if (file2.length > 0) {
          vm.formData.file2 = file2[0].files
        } else {
          vm.formData.file2 = []
        }

        vm.dialogFormVisible = true
      }
    },
    normalizeSpecialties(specialties) {
      if (!Array.isArray(specialties)) {
        return []
      }

      return specialties
        .map(item => (typeof item === 'object' ? item.code || item.name || item.label : item))
        .filter(item => typeof item === 'string' && item.trim())
        .map(item => item.trim())
    },
    validateProfileImages(uploadComponents) {
      const acceptedMimeTypes = ['image/jpeg', 'image/png', 'image/webp']
      const maxBytes = 5 * 1024 * 1024
      const newFiles = uploadComponents.reduce((files, component) => {
        return files.concat(this.filterFiles(1, component.fileList))
      }, [])

      const invalidFile = newFiles.find(file => {
        return !file.raw || !acceptedMimeTypes.includes(file.raw.type) || file.raw.size > maxBytes
      })

      if (invalidFile) {
        this.$message.error('圖片僅支援 JPEG、PNG 或 WebP，且每張不得超過 5 MB。')
        return false
      }

      return true
    },
  },
}
</script>
<style>
.el-dialog__body {
  padding: 15px;
}
</style>

<style scoped>
/deep/.leader-data .el-form .is-disabled * {
  color: blue !important;
}
</style>
<style lang="scss" scoped>
.full-height {
  position: relative;
  height: 100%;
}
.el-dialog__body {
  padding-top: 15px !important;
}
</style>
